<section class="calendar-view-instance">
    <div [class]="{'survey-cal-card-due': active && dayHasSurvey(), 'survey-cal-card': !active && dayHasSurvey()}">
          <!-- Desktop -->
        <div class="uscb-hide-xs uscb-hide-sm uscb-hide-md ecorr-calendar-year-summary-{{ currentStatusString() }}">
            <div class="survey-cal-day-date">
                <div>{{ date.date | date: 'd' }}</div>
            </div>

            @if (date.surveys.length > 0) {
            <div class="uscb-layout-column">
                <div class="f-day uscb-text-align-center">
                    {{ date.surveys.length }} survey{{ date.surveys.length > 1 ? 's' : '' }}
                    @if (active) {
                    <span class="uscb-hide-xs uscb-hide-sm uscb-hide-md">due</span>
                    }
                    @if (!active) {
                    <span class="uscb-hide-xs uscb-hide-sm uscb-hide-md">closed</span>
                    }
                </div>
                <button class="uscb-primary-button uscb-flex-row" (click)="openDueSurveysDialog()" (keyup.enter)="openDueSurveysDialog()" tabindex="0">VIEW</button>
            </div>
            }
        </div>

          <!-- Mobile -->
        @if (date.isActiveMonth) {
        <div class="uscb-hide-gt-md ecorr-border-grey-1 fx-row"
            [class.survey-cal-mobile-clickable]="active && dayHasSurvey()"
            (click)="active && dayHasSurvey() ? openDueSurveysDialog() : null"
            (keyup.enter)="active && dayHasSurvey() ? openDueSurveysDialog() : null"
            [attr.tabindex]="active && dayHasSurvey() ? 0 : null">
            <div class="survey-cal-day-date fx-col fx-align-center fx-flex-none"
                [ngClass]="{ 'survey-cal-day-date-has-survey' : dayHasSurvey() }">
                <div class="f-16">{{ date.date | date: 'EEE' }}</div>
                <div class="f-18">{{ date.date | date: 'd' }}</div>
            </div>
            @if (date.surveys.length > 0) {
            <div class="fx-flex-auto">
                @for (survey of date.surveys; track survey.brOrganizationId) {
                <div class="uscb-layout-column uscb-layout-align-flex-start uscb-layout-align-vert-stretch">
                    <div class="name-csr">
                        <h3>{{ survey.displayName }}</h3>
                        <div><b>ID: </b> {{survey.brOrganizationId}}</div>
                    </div>
                </div>
                }
            </div>
            }
        </div>
        }
    </div>
</section>